// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAy2x-uI-_GYH_c3ZGeErP8abs9heymduM",
    authDomain: "college-playbook-dev.firebaseapp.com",
    projectId: "college-playbook-dev",
    storageBucket: "college-playbook-dev.firebasestorage.app",
    messagingSenderId: "764593959186",
    appId: "1:764593959186:web:424596f6a8e09f73da83cb"
  },
  // apiUrl: 'http://127.0.0.1:5001/college-playbook-dev/southamerica-east1/api',
  apiUrl: 'https://api-kqiarwaa4a-rj.a.run.app',
  stripeKey: "pk_test_51PTrzVIWlP7xxSReEjGJLWzmCdn7wXP3huLqwXjHUNCuC5AKBuYx8Pm1hh03EU6XgjX19GNot9Pr5fsVpa59NAtL00z19xZqgJ"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
